import { QueryClient, useMutation } from "@tanstack/react-query"
import { useState } from "react"
import { messageError, messagePending, messageSuccess } from "../../service/messages"
import { addOrderRequest } from "./apiCalls"
import { OrderType } from "../types"

// upload document(s) to employee
export const useAddOrderRequest = (queryClient: QueryClient, queryKey: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, OrderType>({
        mutationFn: addOrderRequest,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Die Anfrage wird gerade erstellt.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Die Anfrage wurde erfolgreich gestellt. Wir melden uns zeitnah!")
            queryClient.invalidateQueries({ queryKey: [queryKey] })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", "Die Anfrage konnte nicht gestellt werden.")
            console.log(err)
        },
    })

    return mutation
}
